var UserTypeConstants = /** @class */ (function () {
    function UserTypeConstants() {
    }
    UserTypeConstants.DWN_USER = 'NETCRACKER';
    UserTypeConstants.LEGACY_USER = 'TELENET_LEGACY';
    UserTypeConstants.RESIDENTIAL_USER = 'RESIDENTIAL';
    UserTypeConstants.BUSINESS_USER = 'BUSINESS';
    return UserTypeConstants;
}());
export { UserTypeConstants };
